import React, { useCallback } from 'react';
import { AxiosError } from 'axios';
import { SnackbarKey, useSnackbar } from 'notistack';
import { AppButton } from '../components/app/button/appButton';

interface UseAppSnackbarReturn {
  onErrorSnackbar: (error: Error | AxiosError, defaultMessage?: string) => void;
}

const useAppSnackbar = (
  onDismissCallback?: () => void
): UseAppSnackbarReturn => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onCloseSnackBar = useCallback(
    (snackbarId?: SnackbarKey | undefined) => {
      if (onDismissCallback) onDismissCallback();
      closeSnackbar(snackbarId);
    },
    [closeSnackbar, onDismissCallback]
  );

  const action = useCallback(
    (snackbarId: number) => (
      <AppButton
        label="Dismiss"
        isPrimary
        sx={{ color: 'white', boxShadow: '' }}
        onClick={() => {
          onCloseSnackBar(snackbarId);
        }}
      />
    ),
    [onCloseSnackBar]
  );

  const onErrorSnackbar = useCallback(
    (error: Error, defaultMessage?: string) =>
      enqueueSnackbar(error.message || defaultMessage, {
        variant: 'error',
        preventDuplicate: true,
        action,
      }),
    [action, enqueueSnackbar]
  );

  return { onErrorSnackbar };
};

export default useAppSnackbar;
